import React from "react";
import Location from "../../models/Location"
import Analytics from "../../components/analytics/Analytics";

const EditLocationAnalytics: React.FC<{data: Location, dimId: string}> = (props) => {
    return <p>No analytics for locations</p>;
};

export default EditLocationAnalytics;
